import { Box } from '@mui/material';
import useBundleTranslation from 'i18n';
import ReactSelect from 'components/common/react-select/ReactSelect';
import { FormComponentValue } from 'components/common/form/layout/control';
import { ReportLensReport } from './types';

const ALL_REPORTS_VALUE = '';

interface ReportLensSelectProps {
    reports: ReportLensReport[];
    selectedReportElementId: number | null;
    onChange: (elementId: number | null) => void;
}

export default function ReportLensSelect({ reports, selectedReportElementId, onChange }: ReportLensSelectProps) {
    const { t } = useBundleTranslation('components/common/knowledge-graph/panel');
    const value = selectedReportElementId != null ? String(selectedReportElementId) : ALL_REPORTS_VALUE;

    const options: FormComponentValue[] = [
        { label: t('report_lens_all'), value: ALL_REPORTS_VALUE },
        ...reports.map((r) => ({ label: r.name, value: String(r.element_id) })),
    ];

    return (
        <Box sx={{ position: 'absolute', top: 8, right: 16, minWidth: 200 }}>
            <ReactSelect
                name="kg_report_lens"
                dataTest="kg_report_lens_select"
                placeholder={t('report_lens_label')}
                data={options}
                value={value}
                update={(raw: string) => onChange(ALL_REPORTS_VALUE === raw ? null : Number(raw))}
            />
        </Box>
    );
}
